import { ANSWER_TYPES, IClientQuestion, IQuestion } from '../interfaces/jobInterface';
import { DEFAULT_ASSESSMENT_DURATION, DEFAULT_ATTEMPTS, DEFAULT_DURATION, DEFAULT_THINKING_TIME } from './constants.utils';

export const convertQuestions = (questions: IClientQuestion[] = []):IQuestion[] => {
  const questionsToReturn = questions.map((q) => {
    const isAssessment = q.answerType && q.answerType !== ANSWER_TYPES.VIDEO;
    return {
      ...q,
      question: q.question || '',
      numOfRetakes: q.attempts || DEFAULT_ATTEMPTS,
      partDuration: q.duration || (isAssessment ? DEFAULT_ASSESSMENT_DURATION : DEFAULT_DURATION),
      thinkingTime: isAssessment ? q.duration || DEFAULT_ASSESSMENT_DURATION : q.thinkingTime || DEFAULT_THINKING_TIME,
    };
  });

  return questionsToReturn;
};
